import MarketRepository from "../../../Main/repository/MarketRepository";
import MarketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import Toast from "../../../../utility/toast";
import {copyToClipboard} from "../../../../utility/copyClipboard";
import {useTranslation} from "react-i18next";

export default function PublicKey() {
    const {t} = useTranslation();
    const setting = MarketRepository.getSettingMarket() as MarketSettingLocalStorage;

    const handleCopy = async () => {
        if (!setting?.publicKey) {
            Toast.error(t("setting.error.publicKeyNotFound"));
            return;
        }

        await copyToClipboard(setting.publicKey, t("setting.success.copySuccess"), t("setting.error.copyFailed"));
    };

    return (
        <section className="public-key-container">
            <p>{t("setting.marketPublicKey")}</p>
            <div className="public-key">
                <input
                    disabled
                    value={setting.publicKey || t("setting.error.publicKeyNotFound")}
                    readOnly
                />
                <button
                    type="button"
                    onClick={handleCopy}
                    disabled={!setting.publicKey}
                >
                    {t("copy")}
                </button>
            </div>
        </section>
    );
}
